// extracted by mini-css-extract-plugin
module.exports = {"main":"heading-module--main--2UA4T","sub":"heading-module--sub--uleSV","minor":"heading-module--minor--143XJ"};